import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import LockButton from "./LockButton";
import { useImmer } from "use-immer";

function Cle(props) {
  const appState = useContext(StateContext);
  const appDispatch = useContext(DispatchContext);

  const [isLoading, setIsLoading] = useImmer(true);

  let navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    setIsLoading(false);
  }, []);

  useEffect(() => {
    appDispatch({ type: "UNLOCK_CHAPTER", chapitreIdx: props.chapitreIdx });
  }, []);

  useEffect(() => {
    localStorage.setItem(
      `${appState.livre.isbn}-chapter-${props.chapitreIdx}-locked`,
      false
    );
  }, [appState.lockCount]);

  function handleContinueClick() {
    appDispatch({
      type: "SET_SCROLL_TO",
      value: parseInt(props.chapitreId) + 1,
    });
    navigate(`/`, { replace: false });
  }

  if (isLoading) return <></>;

  return (
    <>
      <section className="section-pause section-pause--cle">
        <div className="section-pause__container">
          <h2 className="section-pause__container--key-title">
            Félicitations !<br />
            {props.chapitreId}
            <sup>{props.chapitreId == 1 ? "re" : "e"}</sup> clé
          </h2>
          <div className="section-pause__container--key-group">
            {appState.chapitres.map((chapitre, index, { length }) => {
              return <LockButton parentIdx={index} readOnly={true} />;
            })}
          </div>
        </div>
      </section>
      <footer className="page-footer chapitre-footer cle-footer">
        <button onClick={handleContinueClick} className="btn btn-standard">
          Poursuivre l’expédition
        </button>
      </footer>
    </>
  );
}

export default Cle;
